//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import EventCard from "./EventCard.vue";

export default {
  props: ["siteUrl", "postPerPage"],
  name: "FavouritenComponent",
  components: { EventCard },
  data() {
    return {
      data: [],
      view: {
        list: true,
        threeD: false
      },
      hoveredExFilter: undefined,
      noData: false,
      loadMoreClicked: false,
      loading: false,
      navigation: true,
      currentPosts: 0,
      offset: 15,
      deelnemersOptions: [],
      deelnemers1: [],
      deelnemers2: [],
      deelnemers3: [],
      eventOptions: [],
      totalPost: 0,
      formData: {
        offset: 0,
        favourites: [],
        doelgroep: [],
        programma: [],
        post_type: [],
        whd_event_dates: [],
        details: [],
        whd_ticketavailable: [],
        excursie: []
      },
      deelnemerDropdown: false,
      deelnemerTrayOpened: false,
      deelnemerMobileTrayOpened: false,
      childCheckboxOpened: false,
      filtersTrayOpened: false,
      ticketIcons: {
        blue: require("../../images/icon-ticket-blue.svg"),
        grey: require("../../images/icon-ticket-grey.svg")
      }
    };
  },
  computed: {
    // Add computed properties if needed
  },
  mounted() {
    try {
      this.loadProgrammes(false);
    } catch (error) {
      console.error("Error in mounted hook:", error);
    }
  },
  methods: {
    loadProgrammes(loadMore = false) {
      const favs = localStorage.getItem("eventFavourites");
      try {
        this.formData.favourites = favs ? JSON.parse(favs) : [];
      } catch (error) {
        console.error(
          'Error parsing localStorage item "eventFavourites":',
          error
        );
        this.formData.favourites = [];
      }

      if (!loadMore) {
        this.loading = true;
        this.formData.offset = 0;
        this.currentPosts = 0;
        this.navigation = true;
      } else {
        this.loadMoreClicked = true;
      }

      const fD = Object.entries(this.formData).reduce((newObj, [key, val]) => {
        if (key === "offset" || key === "posts_per_page") {
          newObj[key] = val;
        } else {
          if (val && val.length) {
            newObj[key] = val.join();
          }
        }
        return newObj;
      }, {});

      let url = `${this.siteUrl}/wp-json/events/v2/favourite_events`;

      axios
        .get(url, { params: fD })
        .then(response => {
          this.tickets_sales_start = response.data.tickets_sales_start;

          if (response.data.message) {
            this.noData = true;
            this.data = [];
          } else {
            this.noData = false;
            this.totalPost = response.data.total;

            this.currentPosts += this.objectLength(response.data.data);
            if (
              response.data.total <= this.offset ||
              this.currentPosts >= this.totalPost
            ) {
              this.navigation = false;
            }

            if (loadMore) {
              this.data = [...this.data, ...response.data.data];
            } else {
              this.data = response.data.data;
            }
          }

          this.loading = false;
          this.loadMoreClicked = false;
        })
        .catch(error => {
          console.error("Error loading programmes:", error);
          this.loading = false;
          this.loadMoreClicked = false;
        });
    },

    loadMore() {
      this.formData.offset += parseInt(this.offset, 10);
      this.loadProgrammes(true);
    },

    unfavourite(postid) {
      const findIndex = this.data.findIndex(item => item.postid === postid);

      const newdata = [...this.data];
      if (findIndex > -1) {
        newdata.splice(findIndex, 1);
      }
      this.data = newdata;
    },

    objectLength(object) {
      return Object.keys(object).length;
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        if (!newVal) return;

        const {
          deelnemers,
          programma,
          doelgroep,
          whd_event_dates,
          details,
          whd_ticketavailable,
          excursie
        } = newVal;

        const hash = `deelnemers=${deelnemers || ""}&programma=${programma ||
          ""}&doelgroep=${doelgroep || ""}&whd_event_dates=${whd_event_dates ||
          ""}&details=${details ||
          ""}&whd_ticketavailable=${whd_ticketavailable ||
          ""}&excursie=${excursie || ""}`;
        window.location.hash = hash;
      },
      deep: true
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/FavouritenComponent.vue